module.exports = __webpack_public_path__ + "img/news.01974a6c.svg";